<template>
  <div class="font-inter w- h-[1040px] bg-[#FFFFFF] rounded-t-[20px] mt-3">
    <NavbarComponent />

    <div class="mx-8 my-6 ">
      <div class="hr-container space-x5 mb-6 ">
        <div class="flex items-center justify-between">
          <div class="space-y-3">
            <p class="font-semibold text-bodyText text-[20px] space-x-3">Projects</p>
            <p class="text-bodyText text-[14px]"> Assign roles, update permissions, and keep leadership organized.</p>
          </div>
          <div class="flex gap-4">
            <button @click="emitOpenAssignRoleModal" class="flex bg-black hover:bg-gray-400 text-primaryLight text-[14px] font-medium px-3 py-3 space-x-4 items-center rounded-[8px] h-[42px]">
              <img src="@/assets/dashboard/add.svg" alt="User icon" class="h-4">
              Add manager
            </button>
            <button @click="emitOpenCreateProjectModal" class="flex border border-grayLight hover:bg-primaryDark hover:text-primaryLight text-primaryDark text-[14px] font-medium px-6 py-3 space-x-4 items-center rounded-[8px] h-[42px]">
              Export CSV
            </button>            
          </div>
        </div>
      </div>

      <div class="flex ml-auto justify-between mb-8 space-x-6 py-1 text-[14px] rounded-[6px] items-center">
        <p class="flex items-center cursor-pointer gap-2 rounded-[6px] bg-[#FFFFFF] bg-[14px] px-4 py-1 border border-grayLight">
          <img src="@/assets/projects/sort.svg" alt="Icon" class="">            
          Filters
        </p>
      </div>
      <ManagersTable />
      </div>
  </div>
  <AssignRoleModal
    :showModal="showAssignRoleModal"
    :managers="managers"
    @role-assigned="handleRoleAssignedSuccess"
    @close="closeAssignRoleModal"
  />
</template>

<script>
import apiClient from '@/axios';
import NavbarComponent from '../NavbarComponent.vue';
import ManagersTable from './ManagersTable.vue';
import AssignRoleModal from '../modals/AssignRoleModal.vue';
import eventBus from '@/eventBus';



export default {
  name: 'ManagerComponent',
  data() {
    return {
      managers: [],
      loading: true, 
      users: [],
      manager: {},
      showAssignRoleModal: false,
    };
  },
  components: {
    NavbarComponent,
    ManagersTable,
    AssignRoleModal,
  },
  created() {
    this.fetchManagers();
    this.fetchManagers();
  },
  computed: {
    fullName() {
      if (!this.user || (!this.user.first_name && !this.user.last_name)) {
        return '';
      }
      return `${this.user.first_name || ''} ${this.user.last_name || ''}`.trim();
    },
  },
  methods: {
    capitalize(text) {
        if (!text) return '';
          return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
      },
    
    emitOpenAssignRoleModal() {
      eventBus.emit('openAssignRoleModal')
    },
    openAssignRoleModal() {
      this.showAssignRoleModal = true;
    },
    closeAssignRoleModal() {
      this.showAssignRoleModal = false;
    },
    handleRoleAssignedSuccess(message, newManager) {
      this.showAssignRoleModal = false;
      this.$toast.success(message);
      this.managers.push(newManager);
      this.fetchManagers();
    },
    async fetchUsers() {
      try {
        if (this.isAdmin) {
          const response = await apiClient.get('/web/users');
          this.users = response.data.data;
          console.log('Users data:', this.users);          
        }

      } catch (error) {
        console.error('Error fetching users:', error);
      }
    },
    async fetchManagers() {
      try {
        if (this.isAdmin) {
          const response = await apiClient.get('/web/managers');
          this.managers = response.data.data;
          console.log('Managers data:', this.managers); // L
        }
      } catch (error) {
        console.error('Error fetching managers or their data:', error);
        console.error('Error response data:', error.response ? error.response.data : 'No response');
      } finally {
        this.loading = false; // Stop showing the loader once data is fetched
      }
    },
  },
};
</script>

<style scoped>
.animate-pulse {
  animation: pulse 1.5s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.4;
  }
}
</style>
